import { gql, TypedDocumentNode } from "@apollo/client";

import {
  Template,
  TemplateVersion,
  TemplateTemplateVersionArgs,
  TemplateSearchTemplateVersionsArgs,
  TemplateSearchTemplateVersionsSuggestionsArgs,
  MutationTemplateVersionCreateArgs,
  MutationTemplateVersionDeleteArgs,
  MutationTemplateVersionDeprecateArgs,
  MutationTemplateVersionUpdateArgs,
} from "types/generated";

type SearchTemplateVersionsData = {
  template: Template;
};

export const SEARCH_TEMPLATE_VERSIONS: TypedDocumentNode<
  SearchTemplateVersionsData,
  TemplateTemplateVersionArgs & TemplateSearchTemplateVersionsArgs
> = gql`
  query SearchTemplateVersions($id: ID!, $input: SearchInput!) {
    template(id: $id) {
      id
      searchTemplateVersions(input: $input) {
        edges {
          cursor
          node {
            id
            instructions
            name
            state
            space {
              id
              name
              accessLevel
            }
            ulid
            updatedAt
            version
            deploymentsCount
            deprecatedAt
            deprecationNote
          }
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
        }
      }
    }
  }
`;

type SearchTemplateVersionsSuggestionsData = {
  template: Template;
};

export const SEARCH_TEMPLATE_VERSIONS_SUGGESTIONS: TypedDocumentNode<
  SearchTemplateVersionsSuggestionsData,
  TemplateTemplateVersionArgs & TemplateSearchTemplateVersionsSuggestionsArgs
> = gql`
  query SearchTemplateVersionsSuggestions($id: ID!, $input: SearchSuggestionsInput!) {
    template(id: $id) {
      id
      searchTemplateVersionsSuggestions(input: $input) {
        filteredCount
        fields {
          name
          orderable
          filterable
          type
          possibleValuesBoolean {
            values
            counts
          }
          possibleValuesEnum {
            values
            counts
          }
          possibleValuesString {
            values
            counts
          }
          possibleValuesHierarchy {
            values {
              id
              parentId
              displayValue
            }
            counts
          }
        }
      }
    }
  }
`;

type DeleteTemplateVersionData = {
  templateVersionDelete: Pick<TemplateVersion, "id" | "name" | "version">;
};

export const DELETE_VERSION: TypedDocumentNode<
  DeleteTemplateVersionData,
  MutationTemplateVersionDeleteArgs
> = gql`
  mutation TemplateVersionDelete($id: ID!) {
    templateVersionDelete(id: $id) {
      id
      name
      version
    }
  }
`;

type CreateTemplateVersionData = {
  templateVersionCreate: Pick<TemplateVersion, "id" | "name" | "version">;
};

export const CREATE_VERSION: TypedDocumentNode<
  CreateTemplateVersionData,
  MutationTemplateVersionCreateArgs
> = gql`
  mutation TemplateVersionCreate($input: TemplateVersionCreateInput!) {
    templateVersionCreate(input: $input) {
      id
      name
      version
    }
  }
`;

type UpdateTemplateVersionData = {
  templateVersionUpdate: Pick<TemplateVersion, "id" | "name" | "version">;
};

export const UPDATE_VERSION: TypedDocumentNode<
  UpdateTemplateVersionData,
  MutationTemplateVersionUpdateArgs
> = gql`
  mutation TemplateVersionUpdate($id: ID!, $input: TemplateVersionUpdateInput!) {
    templateVersionUpdate(id: $id, input: $input) {
      id
      name
      version
    }
  }
`;

type DeprecateTemplateVersionData = {
  templateVersionDeprecate: Pick<TemplateVersion, "id" | "deprecatedAt" | "deprecationNote">;
};

export const DEPRECATE_VERSION: TypedDocumentNode<
  DeprecateTemplateVersionData,
  MutationTemplateVersionDeprecateArgs
> = gql`
  mutation TemplateVersionDeprecate($id: ID!, $input: TemplateVersionDeprecateInput) {
    templateVersionDeprecate(id: $id, input: $input) {
      id
      deprecatedAt
      deprecationNote
    }
  }
`;
